import { useState, useEffect } from 'react'
import api from '../../utils/api'
import AdminLayout from '../../components/admin/AdminLayout'
import './Admin.css'

interface Semester {
  id: number
  year: number
  season: string
  start_date: string
  end_date: string
  is_active: number
  created_at: string
}

export default function AdminSemesters() {
  const [semesters, setSemesters] = useState<Semester[]>([])
  const [form, setForm] = useState({ year: '', season: '하기', startDate: '', endDate: '', isActive: false })
  const [editingId, setEditingId] = useState<number | null>(null)

  useEffect(() => {
    loadSemesters()
  }, [])

  const loadSemesters = async () => {
    try {
      const res = await api.get('/semesters')
      setSemesters(res.data)
    } catch (err) {
      console.error('학기 로드 오류:', err)
      alert('학기 정보를 불러오는데 실패했습니다.')
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      if (editingId) {
        // 수정
        await api.put(`/semesters/${editingId}`, form)
        alert('수정되었습니다.')
        setEditingId(null)
      } else {
        // 등록
        await api.post('/semesters', form)
      alert('등록되었습니다.')
      }
      setForm({ year: '', season: '하기', startDate: '', endDate: '', isActive: false })
      loadSemesters()
    } catch (err: any) {
      alert(err.response?.data?.error || '작업에 실패했습니다.')
    }
  }

  const handleEdit = (semester: Semester) => {
    setEditingId(semester.id)
    setForm({
      year: semester.year.toString(),
      season: semester.season,
      startDate: semester.start_date || '',
      endDate: semester.end_date || '',
      isActive: semester.is_active === 1
    })
  }

  const handleCancelEdit = () => {
    setEditingId(null)
    setForm({ year: '', season: '하기', startDate: '', endDate: '', isActive: false })
  }

  const toggleActive = async (semester: Semester) => {
    try {
      await api.put(`/semesters/${semester.id}`, {
        ...semester,
        isActive: semester.is_active === 1 ? false : true
      })
      alert('활성 상태가 변경되었습니다.')
      loadSemesters()
    } catch (err: any) {
      alert(err.response?.data?.error || '상태 변경에 실패했습니다.')
    }
  }

  return (
    <AdminLayout>
    <div className="admin-page">
      <h1>학년도/계절 관리</h1>
      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-row">
          <label>학년도:</label>
          <input 
            type="number" 
            value={form.year} 
            onChange={(e) => setForm({...form, year: e.target.value})} 
            required 
            placeholder="예: 2025"
          />
        </div>
        <div className="form-row">
          <label>계절:</label>
          <select value={form.season} onChange={(e) => setForm({...form, season: e.target.value})}>
            <option value="하기">하기</option>
            <option value="동기">동기</option>
          </select>
        </div>
        <div className="form-row">
          <label>시작일:</label>
          <input 
            type="date" 
            value={form.startDate} 
            onChange={(e) => setForm({...form, startDate: e.target.value})} 
            min="2020-01-01"
            max="2099-12-31"
          />
        </div>
        <div className="form-row">
          <label>종료일:</label>
          <input 
            type="date" 
            value={form.endDate} 
            onChange={(e) => setForm({...form, endDate: e.target.value})} 
            min="2020-01-01"
            max="2099-12-31"
          />
        </div>
        <div className="form-row">
          <label>
            <input 
              type="checkbox" 
              checked={form.isActive} 
              onChange={(e) => setForm({...form, isActive: e.target.checked})} 
            />
            활성 학기로 설정
          </label>
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            {editingId ? '수정' : '등록'}
          </button>
          {editingId && (
            <button type="button" onClick={handleCancelEdit} className="btn-secondary">
              취소
            </button>
          )}
        </div>
      </form>
      <div className="admin-list">
        <h2>등록된 학기</h2>
        {semesters.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            등록된 학기가 없습니다.
          </p>
        ) : (
        <table>
          <thead>
            <tr>
              <th>학년도</th>
              <th>계절</th>
              <th>시작일</th>
              <th>종료일</th>
              <th>활성</th>
                <th>작업</th>
            </tr>
          </thead>
          <tbody>
            {semesters.map(s => (
                <tr key={s.id} style={{ backgroundColor: s.is_active ? '#f0f8ff' : 'transparent' }}>
                <td>{s.year}</td>
                <td>{s.season}</td>
                <td>{s.start_date || '-'}</td>
                <td>{s.end_date || '-'}</td>
                  <td>
                    <span style={{ 
                      color: s.is_active ? '#28a745' : '#ccc',
                      fontWeight: s.is_active ? 'bold' : 'normal'
                    }}>
                      {s.is_active ? '✓ 활성' : '비활성'}
                    </span>
                  </td>
                  <td>
                    <button 
                      onClick={() => handleEdit(s)} 
                      className="btn-secondary"
                      style={{ marginRight: '5px' }}
                    >
                      수정
                    </button>
                    <button 
                      onClick={() => toggleActive(s)} 
                      className="btn-primary"
                      style={{ fontSize: '0.85em' }}
                    >
                      {s.is_active ? '비활성화' : '활성화'}
                    </button>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
    </div>
    </AdminLayout>
  )
}

